export default __webpack_public_path__ + "e16236243af98fc47f9d36eeffd69464.wav";